<template>
  <div id="app">
    <nav>
      <router-link to="/"></router-link>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.setTitle(this.$route);
    this.$router.afterEach((to) => {
      this.setTitle(to);
    });
  },
  methods: {
    setTitle(route) {
      const defaultTitle = 'R星出品|必属精品';
      const routeTitle = route.meta.title || defaultTitle;
      document.title = routeTitle;
    }
  }
};
</script>